import $ from "jquery";



const _body          = $('body');
const _menuButton    = $("#menu-button");
const _searchButton  = $("#search-button");
const _searchReset   = $(".search-reset");
const _searchForm    = $("#search");
const _searchTerms   = $("#search-terms");

const openCloseMenu = function(e) {

   console.log("openCloseMenu");
   e.preventDefault();
   if (_body.hasClass('show-menu')){
      _body.removeClass("show-menu");
   } else {
      _body.addClass("show-menu");
   }
 }


 const openCloseSearch = function(e) {

   e.preventDefault();
   if (_body.hasClass('show-search')){
      _body.removeClass("show-search");
   } else {
      _body.addClass("show-search");
   }
 }

const captureFormSumbit = function(e) {
   if (e.which == 13) {
      _searchTerms.val("vendor:w26 " + _searchTerms.val());
      _searchForm.submit();
     return false;    //<---- Add this line
   }
 };

export const initMenu = function() {

   console.log("Init Menu");
   _menuButton.on("click",openCloseMenu);
   _searchButton.on("click",openCloseSearch);
   _searchReset.on("click",openCloseSearch);
   _searchTerms.on("keypress",captureFormSumbit);
   
};